import type { DeletePriorityResponse } from '../../common/types';

export const refineDeletePriorityResponse = (obj: unknown): DeletePriorityResponse => {
	if (
		!obj ||
		typeof obj !== 'object' ||
		!('self' in obj) ||
		typeof obj.self !== 'string' ||
		!('status' in obj) ||
		typeof obj.status !== 'string'
	) {
		throw new Error('Unexpected shape of DeletePriorityResponse');
	}

	return {
		self: obj.self,
		status: obj.status,
	};
};
